import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface NotifyState {
    /** 系统通知 */
    systemNotify: ListWrap<Notify.SystemNotify> & ListRequesting;
    /** 点赞 */
    like: ListWrap<Notify.Like> & ListRequesting;
    /** 回复 */
    reply: ListWrap<Notify.Reply | Notify.Comment> & ListRequesting;
    /** 是否有红点 */
    redPoint: {
        notify: boolean,
        reply: boolean,
        like: boolean,
    };
}

const m: Module<NotifyState, RootState> = {
    namespaced: true,
    state: () => ({
        systemNotify: {
            list: [],
            loaded: false,
            requesting: false,
        },
        like: {
            list: [],
            loaded: false,
            requesting: false,
        },
        reply: {
            list: [],
            loaded: false,
            requesting: false,
        },
        redPoint: {
            notify: false,
            reply: false,
            like: false,
        },
    }),
    mutations: {
        /**
         * 添加系统通知
         */
        concatSystemNotify(state, list) {
            state.systemNotify.list.push(...list);
        },
        /**
         * 是否全部加载
         */
        setSystemNotifyLoaded(state, loaded) {
            state.systemNotify.loaded = loaded;
        },
        /**
         * 是否正在加载
         */
        setSystemNotifyReq(state, req) {
            state.systemNotify.requesting = req;
        },
        /**
         * 添加点赞
         */
        concatLike(state, list) {
            state.like.list.push(...list);
        },
        /**
         * 是否全部加载
         */
        setLikeLoaded(state, loaded) {
            state.like.loaded = loaded;
        },
        /**
         * 是否正在加载
         */
        setLikeReq(state, req) {
            state.like.requesting = req;
        },
        /**
         * 添加回复
         */
        concatReply(state, list) {
            state.reply.list.push(...list);
        },
        /**
         * 是否全部加载
         */
        setReplyLoaded(state, loaded) {
            state.reply.loaded = loaded;
        },
        /**
         * 是否全部请求
         */
        setReplyReq(state, req) {
            state.reply.requesting = req;
        },
        /**
         * 记录红点
         */
        setRedPoint(state, redpoint) {
            state.redPoint = redpoint;
        },
    },
    actions: {
        /**
         * 获取通知
         */
        async getSystemNotify({ state, commit }, { lastId, count, forceUpdate }: {
            lastId: number | undefined, count: number, forceUpdate?: boolean,
        }) {
            const wrap = state.systemNotify;
            if (wrap.requesting || (wrap.loaded && !forceUpdate)) {
                return;
            }
            if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
            }
            commit('setSystemNotifyReq', true);
            const response = await Vue.axios.get('/api/v1/system_notice/notice_list', {
                params: {
                    last_id: lastId,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('concatSystemNotify', rdata.data);
                if (rdata.data.length < count) {
                    commit('setSystemNotifyLoaded', true);
                }
            }
            commit('setSystemNotifyReq', false);
            return rdata;
        },
        /**
         * 点赞列表
         */
        async getLike({ state, commit }, { lastId, count, forceUpdate }: {
            lastId: number | undefined, count: number, forceUpdate?: boolean,
        }) {
            const wrap = state.like;
            if (wrap.requesting || (wrap.loaded && !forceUpdate)) {
                return;
            }
            if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
            }
            commit('setLikeReq', true);
            const response = await Vue.axios.get('/api/v1/system_notice/like_list', {
                params: {
                    last_id: lastId,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = rdata.data;
                list.forEach((item: Notify.Like) => {
                    item.id = item.like_id;
                });
                commit('concatLike', list);
                if (list.length < count) {
                    commit('setLikeLoaded', true);
                }
            }
            commit('setLikeReq', false);
            return rdata;
        },
        /**
         * 回复列表
         */
        async getReply({ state, commit }, { lastId, count, forceUpdate }: {
            lastId: number | undefined, count: number, forceUpdate?: boolean,
        }) {
            const wrap = state.reply;
            if (wrap.requesting || (wrap.loaded && !forceUpdate)) {
                return;
            }
            if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
            }
            commit('setReplyReq', true);
            const response = await Vue.axios.get('/api/v1/system_notice/reply_list', {
                params: {
                    last_id: lastId,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = rdata.data;
                commit('concatReply', list);
                if (rdata.data.length < count) {
                    commit('setReplyLoaded', true);
                }
            }
            commit('setReplyReq', false);
            return rdata;
        },
        /**
         * 是否有红点
         */
        async checkRedPoint({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/system_notice/check');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setRedPoint', {
                    notify: rdata.data.notice,
                    reply: rdata.data.reply,
                    like: rdata.data.like,
                });
            }
            return rdata;
        },
    },
};

export default m;
